import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";

import { teamData } from "../data";

const Team = () => {
  const { title, sub1, sub2, name, occupation } = teamData;
  return (
    <section className="relative top-96 z-10 lg:top-[480] min-h-[720px]">
      <div className="container mx-auto">
        <div className="flex flex-col items-center lg:flex-row lg:gap-x-[120px] lg:items-start">
          <motion.div
            variants={fadeIn("down", "tween", 0.6, 1.6)}
            initial="hidden"
            whileInView={"show"}
            className="flex-1 text-center lg:text-left lg:pt-16"
          >
            <div className="flex justify-center items-center text-red-300 h2 capitalize">
              {title}
            </div>
            <p className="text-center mb-[60px]">{sub1}</p>
            <p>{sub2}</p>
            <div className="my-[26px]">
              <div className="flex justify-center items-center text-red-300 text-2xl capitalize font-semibold">
                {name}
              </div>
              <div className="flex justify-center items-center text-[15px] font-semibold capitalize text-grey/70">
                {occupation}
              </div>
            </div>
          </motion.div>
          {/* <motion.div
            variants={fadeIn("up", "tween", 0.7, 1.6)}
            initial="hidden"
            whileInView={"show"}
            className="flex-1"
          >
            <img src={chefImg} alt="chef" />
          </motion.div> */}
        </div>
      </div>
    </section>
  );
};

export default Team;
